import React, { ReactNode } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize, typography } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
/*
  This component is a stopgap in order to deprecate @atlaskit/field-base

  New form components should be built using render props and a compliant
    form field label associated by an ID.
  https://atlassian.design/components/textfield/examples
*/

type FieldLabelProps = {
  children: string | ReactNode;
  htmlFor: string;
  isRequired?: boolean;
};

const Label = styled.label`
  ${typography.h200() as any};
  display: inline-block;
  margin-bottom: ${gridSize() / 2}px;
  margin-right: ${gridSize() / 2}px;
`;

const RequiredWrapper = styled.span`
  color: ${token('color.text.danger', colors.R400)};
  margin-left: ${gridSize() / 4}px;
`;

const FieldLabel = ({
  children,
  htmlFor,
  isRequired = false,
}: FieldLabelProps): JSX.Element => {
  return (
    <Label htmlFor={htmlFor}>
      {children}
      {isRequired && <RequiredWrapper aria-hidden>*</RequiredWrapper>}
    </Label>
  );
};

export default FieldLabel;
